import { useMemo } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { routesCompany, routesSuperAdmin, routesAccountingFirm } from './routes';

import { UserRole } from './types/auth';
import { EMPLOYEE_ROUTE_REGISTRY } from './routes/employee.route';
import { AppWithProviders } from './AppWithProviders';
import useAuth from './hooks/useAuth';
import useAuthInit from './hooks/useAuthInit';

function getRootWrappedRoutes(routes: any[]) {
  return [
    {
      path: '',
      element: <AppWithProviders />,
      children: routes,
    },
  ];
}

export function AppRouterProvider() {
  const { user } = useAuth();
  const roleType = user ? user.role.role : null;

  useAuthInit();

  const routes = useMemo(() => {
    if (roleType === UserRole.EMPLOYEE) {
      return getRootWrappedRoutes(EMPLOYEE_ROUTE_REGISTRY);
    } else if (roleType === UserRole.COMPANY_ADMIN) {
      return getRootWrappedRoutes(routesCompany);
    } else if (roleType === UserRole.ACCOUNTING_FIRM) {
      return getRootWrappedRoutes(routesAccountingFirm);
    } else {
      return getRootWrappedRoutes(routesSuperAdmin);
    }
  }, [roleType]);

  const router = useMemo(() => createBrowserRouter(routes), [routes]);

  return <RouterProvider router={router} />;
}
